import { TimeRangeResponse } from '@kcftech/prometheus-client';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export function useTimeRangesForLocation(
    locationId: string,
): UseQueryResult<TimeRangeResponse[], unknown> {
    return useQuery({
        queryKey: ['time-ranges-by-location', locationId],

        queryFn: () => sdClient.getTimeRangesByLocation({ locationId }),
    });
}
